import { FC } from 'react'

import clsx from 'classnames'

import styles from './ErrorAlert.module.scss'

type ErrorAlertProps = {
  message?: string
  className?: string
}

export const ErrorAlert: FC<ErrorAlertProps> = ({ message, className }) => {
  if (!message) return null

  return (
    <div className={clsx(styles.errorAlert, className)} role='alert'>
      {message}
    </div>
  )
}
